import { yupResolver } from "@hookform/resolvers/yup";
import React, { useEffect, useMemo, useState } from "react";
import { useForm } from "react-hook-form";
import * as Yup from "yup";
import { FormInput } from "../../wrappers/formInput";
import { Editor } from "react-draft-wysiwyg";
import {
  EditorState,
  convertToRaw,
  convertFromRaw,
  Modifier,
  ContentState,
} from 'draft-js';
import { DropDownInput } from "../../wrappers/selectInput";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import Button from "../../components/button";
import FormHead from "../../components/headings/FromHead";
import AddLocation from "../../modal/addLocation";
import { Icon } from '@iconify/react';
import Styles from "./styles.module.scss";
import ProfilePicture from "../../modal/profilePicture";
import { RadioInput } from "../../wrappers/radioInput";
import * as CONSTANTS from '../../utils/CONSTANTS';
import { updateLocation } from "./services";
import NotificationAlert from '../../components/notification';
import {checkSize} from '../../utils/EllowUtils';
import { useNavigate } from "react-router-dom";
import PlacesAutocomplete, {
  geocodeByAddress,
  geocodeByPlaceId,
  getLatLng,
} from 'react-places-autocomplete';

const { v4: uuidv4 } = require('uuid');

export type profile = {
  ellowurl: string;
  linkedInurl: string;
  description: string;
  role: string;
  website: string;
  companySize: any;
  currencyType: any;
  workWithRemote: number;
}

interface Props {
  defaultValues?: any;
  clickHandler?: any;
  locationChange?: any;
  defImage?: string;
  customerId?: any;
  companyType?: number;
}

const Profile: React.FC<Props> = ({ defaultValues , clickHandler, locationChange, defImage , customerId, companyType}) => {
  const [editorState, setEditorState] = useState<any>(
    EditorState.createEmpty()
  )

  const navigate = useNavigate()
  const [newLocation, setNewLocation] = useState<boolean>(false)
  const [modal , setModal] = useState<boolean>()
  const [editLocation, setEditLocation] = useState<boolean>(false)
  const [defaultLocation,setDefaulltLocation] = useState<any>()
  const [image, setImage] = useState<any>()
  const [notification, setNotification] = useState<boolean>(false)
  const [message, setMessage] = useState<string>('')
  const [locations, setLocations] = useState<any>()
  const [companyName, setCompanyName] = useState<string>('')

  const [address, setAddress] = useState('')
  const [locationArray, setLocationArray] = useState<{id:string, name:string}[]>([])

  const validationSchema = Yup.object({
    website: Yup.string().required("Field is required"),
    companySize: Yup.object().required("Field is required"),
  })

  const formOptions = {
    resolver: yupResolver(validationSchema),
    defaultValues: useMemo(() => {
      return defaultValues;
    }, [defaultValues]),
  }

  useEffect(() => {
    
    if (defaultValues && defaultValues.customer_metadata) {
      
      setValue('ellowurl', defaultValues.customer_metadata.profileUrl)
      setValue('linkedInurl', defaultValues.customer_metadata.linkedinId)
      setValue('website', defaultValues.customer_metadata.website)
      setValue('currencyType', defaultValues.customer_metadata.currencyType)
      setValue('companySize', checkSize(defaultValues.customer_metadata.size))
      setValue('workWithRemote', defaultValues.customer_metadata.workWithRemote)
      setCompanyName(defaultValues.customer_metadata.companyName)
      setValue('description', defaultValues.customer_metadata.aboutCompany)
      setLocationArray(defaultValues.customer_metadata.googleLocations ? defaultValues.customer_metadata.googleLocations : [])
      const contentState = editorState.getCurrentContent();
      if (JSON.stringify(convertToRaw(contentState)) !== defaultValues.customer_metadata.aboutCompany) {
        try {
          setEditorState(EditorState.createWithContent(convertFromRaw(JSON.parse(defaultValues.customer_metadata.aboutCompany)))); 
        }
        catch (e) {
          //setEditorState(EditorState.createWithContent(ContentState.createFromText(defaultValues.customer_metadata.aboutCompany)));
        }
      }
    }  
    if (defaultValues && defaultValues.customer_metadata && defaultValues.customer_metadata.location) {
     setLocations(defaultValues.customer_metadata.location)
   }
  }, [defaultValues])

  useEffect(() => {
   
    setImage(defImage)
  
  }, [defImage])
  

  const { register, handleSubmit, control, setValue, formState } =
    useForm<profile>(formOptions);

  const onEditorStateChange = (state: any) => {
    setEditorState(state);
    const contentState = state.getCurrentContent();
    setValue("description", JSON.stringify(convertToRaw(contentState)));
  }

  const onSubmit = (data: any) => {
    data.image = image;
    data.googleLocations = locationArray
    clickHandler(data)
  }

  
  // const addNewLocation = (data: any, type?: string, locationId?: string) => {  
  // let body = {
  //   "action":type,
  //   "customerId":customerId,
  //   "customerMetadata":{
  //   "location":[ {
  //   "locationId":locationId ? locationId : null,
  //   "city": data.city,
  //   "state": data.state,
  //   "country": data.country,
  //   "zipCode": data.zipCode,
  //   "streetAddress1":data.streetAddress1,
  //   "streetAddress2":data.streetAddress2
  //      }]
  //   }
  //   }
  //   updateLocation(body).then((response: any) => {

  //     if (response && response.status === 1) {
  //       if(type === 'delete'){
  //         setMessage('Details deleted successfully')
  //         setNotification(true)
  //         setTimeout(() => {
  //         setNotification(false)
  //         }, 3000) 
  //       }
  //       else{
  //         displayNotification()
  //       }
  //       locationChange()
  //       setNewLocation(false)
  //       setEditLocation(false)
  //       locationChange(body.customerMetadata.location)
  //       if (type === 'add') {
  //        locations.push(body.customerMetadata.location)
  //       }
      
  //     }
  //   })
  // }

  const handleChange = (e: any) => {
    setValue('workWithRemote', e.value)  
  }

  const uploadPicture = () => {
    setModal(true)
  }

  const onClose = () => {
    setModal(false)
    setNotification(false)
  }

  const back = () => {
    setNewLocation(false)
    navigate('/company')
  }

  const handleSelect = async (value: any) => {

    const results = await geocodeByAddress(value);
    let data = {
      "id": uuidv4(),
      "name": results[0].formatted_address
    }    
    setLocationArray([...locationArray, data])
    setAddress('')
  }

  const removeLocation = (item: any) => {
    const index = locationArray.findIndex(findItem => findItem.id === item.id); 
    locationArray.splice(index, 1);
    setLocationArray([...locationArray])
  }

  return (
    <section>
      <figure className={Styles.uploadPicWrap}>
        {image ? <img src={image} /> :
          <span className={Styles.noPicWrap}>{companyName[0]}{companyName[1]}</span>
          }
          <span className={Styles.uploadPic}>
            <button onClick={uploadPicture}><Icon icon="ant-design:camera-outlined" /></button>
          </span>
      </figure>
      <form>
        <div className="form-group">
          <FormHead>Basic Information</FormHead>
          <FormInput<profile>
            id="ellowurl"
            type="email"
            name="ellowurl"
            label="URL for ellow.io profile"
            placeholder="ellow.io/in/profiles"
            register={register}
            errors={formState.errors}
          />
        </div>
        <div className="form-group">
          <label className="lablel"><Icon icon="jam:linkedin-square" />LinkedIn  URL</label>
          <FormInput<profile>
            id="linkedInurl"
            type="text"
            name="linkedInurl"
            label=""
            placeholder="www.linkedin.com/in/yourusername"
            register={register}
            errors={formState.errors}
          />
        </div>
        <div className="form-group">
          <label className="lablel">About the company</label>
          <Editor
            editorState={editorState}
            toolbarClassName="toolbarClassName"
            wrapperClassName="wrapperClassName"
            editorClassName="editorClassName"
            onEditorStateChange={onEditorStateChange}
          />
        </div>
        <div className="half-form-wrap">
          <div className="form-group">
            <label className="lablel">Company Website*</label>
            <FormInput<profile>
              id="website"
              type="text"
              name="website"
              placeholder="www.yourcompany.com"
              register={register}
              errors={formState.errors}
            />
          </div>
          <div className="form-group">
            <label className="lablel">Company size*</label>
            <DropDownInput<profile>
              name="companySize"
              label=""
              data={[{ id: 0, name: '1-10' }, { id: 1, name: '11-50' }, { id:2, name: '51-250' }, {id:3, name: '251-10k'}, {id:4, name: '10k+'}]}
              register={register}
              errors={formState.errors}
              control={control}
              dataItemKey='id'
              textField='name'
            />
          </div>
        </div>
        <div className="half-form-wrap">
          <div className="form-group">
            <label className="lablel">Preferred Currency</label>
            <DropDownInput<profile>
              name="currencyType"
              register={register}
              errors={formState.errors}
              data={['INR','USD']}
              control={control}
            />
          </div>
        </div>
        {companyType && companyType === 1 && <FormHead>Are you okay to work with remote developers?*</FormHead>}
        {companyType && companyType === 1 && <RadioInput<profile>
          data={CONSTANTS.remoteWork}
          layout='horizontal'
          name="workWithRemote"
          handleChange={(e: any) => handleChange(e)}
          checked={1}
          register={register}
          errors={formState.errors}
          control={control}
        />}
        <div className={Styles.subHeadWrap}>
          <FormHead>Locations</FormHead>
          {/* <a onClick={() => setNewLocation(true)}><Icon icon="fluent:add-16-filled" /> Add a new location</a> */}
        </div>
        <div className='preference-form-wrapper'>
           <div className="form-group">
                { <PlacesAutocomplete
                  value={address}
                  onChange={setAddress}
                  onSelect={handleSelect}
                >
                  {({getInputProps, suggestions, getSuggestionItemProps, loading}) => (
                    <div className="search-filed">
                      <Icon icon="carbon:search"/>
                      <input
                          {...getInputProps({
                            placeholder: 'Search Places ...',
                            className: 'location-search-input field',
                          })}
                        />
                        { suggestions && suggestions.length > 0 && <div  className="suggestion-list">
                          { loading ? <div className="suggestion-item">...loading</div> : null }
                          {suggestions.map(suggestion => {
                            return (
                              <div {...getSuggestionItemProps(suggestion)} className="suggestion-item">
                                {suggestion.description}
                              </div>
                            );
                          })}
                        </div>}
                    </div>
                  )}

                </PlacesAutocomplete>}
            </div>
            </div>
        <ul className={Styles.addressList}>
          {locationArray && locationArray.map((item: any) => {
              return (
                < li >
                <Icon icon="ep:location" className={Styles.location} />
                <div className={Styles.addressLine}>
                    <div>
                      {item.name}
                      {/* <h3>{item.streetAddress1} . { item.streetAddress2} </h3>
                      <p>{item.city}, {item.state}, {item.country}, {item.zipCode}</p> */}
                    </div>
                    <div className={Styles.addressAction}>
                      {/* <Icon icon="lucide:edit-2" onClick={() => { setEditLocation(true); setDefaulltLocation(item)}}/> */}
                      <Icon icon="icon-park-outline:delete" onClick={() => removeLocation(item)}/>
                    </div>
                </div>
              </li>
             )
            })
          }
      </ul>
      <div className="action-form">
        <Button onClick={() => back()} variant="cancel">
          Back
        </Button>
        <Button onClick={handleSubmit(onSubmit)} variant="primary">
          Save
        </Button>
      </div>
      </form>
      {/* {newLocation && (
        <AddLocation
          clickHandler={(data: any) => addNewLocation(data, 'add', '')}
          onClose={() => setNewLocation(false)}
        />
      )} 
      {editLocation && (
        <AddLocation
          clickHandler={(data: any) => addNewLocation(data, 'update', data.locationId)}
          defaultValues={defaultLocation}
          onClose={() => setEditLocation(false)}
        />
      )}  */}
      {modal && <ProfilePicture onClose={onClose} submitImage={(image: any) => { setImage(image); setModal(false) }} defImage={image} companyName={companyName} customerId={customerId}/>}
      {notification && <NotificationAlert onClose={onClose} closable={true} >
          {message}
        </NotificationAlert> }
    </section>
  )
}
export default Profile;
